if (!customElements.get('pickup-availability')) {
  customElements.define('pickup-availability', class PickupAvailability extends HTMLElement {
    constructor() {
      super();

      this.abortController = null;
      this.onClickRefreshList = this.onClickRefreshList.bind(this);

      if (!this.hasAttribute('available')) return;

      this.fetchAvailability(this.dataset.variantId);

    }

    disconnectedCallback() {
      this.abortAvailabilityFetch();
    }

    fetchAvailability(variantId) {
      if (!variantId) return;

      const requestedVariantId = String(variantId);
      if (this.dataset.variantId && this.dataset.variantId !== requestedVariantId) {
        this.clearAvailability(requestedVariantId);
      } else {
        this.abortAvailabilityFetch();
        this.dataset.variantId = requestedVariantId;
      }

      let rootUrl = this.dataset.rootUrl;
      if (!rootUrl.endsWith("/")) {
        rootUrl = rootUrl + "/";
      }
      const variantSectionUrl = `${rootUrl}variants/${variantId}/?section_id=pickup-availability`;
      const abortController = new AbortController();
      this.abortController = abortController;
      this.setAttribute('aria-busy', 'true');

      fetch(variantSectionUrl, {
        signal: abortController.signal
      })
        .then(response => {
          if (!response.ok) throw new Error(`Pickup availability request failed with status ${response.status}`);
          return response.text();
        })
        .then(text => {
          if (abortController.signal.aborted || this.dataset.variantId !== requestedVariantId) return;

          const sectionInnerHTML = new DOMParser()
            .parseFromString(text, 'text/html')
            .querySelector('.shopify-section');
          this.renderPreview(sectionInnerHTML);

        })
        .catch(e => {
          if (e.name === 'AbortError') return;

          const button = this.querySelector('button');
          if (button) button.removeEventListener('click', this.onClickRefreshList);
          this.renderError();
        })
        .finally(() => {
          if (this.abortController !== abortController) return;

          this.abortController = null;
          this.removeAttribute('aria-busy');
        });
    }

    abortAvailabilityFetch() {
      if (!this.abortController) return;

      this.abortController.abort();
      this.abortController = null;
      this.removeAttribute('aria-busy');
    }

    clearAvailability(variantId) {
      this.abortAvailabilityFetch();
      if (variantId) this.dataset.variantId = String(variantId);

      this.removeAttribute('available');
      this.innerHTML = '';

      const drawer = document.getElementById('Pickup-Availability');
      if (!drawer) return;

      const drawerWasOpen = drawer.classList.contains('active');
      drawer.classList.remove('active');
      drawer.innerHTML = '';

      if (drawerWasOpen) {
        document.body.classList.remove('open-cc');
      }
    }

    onClickRefreshList(evt) {
      evt?.preventDefault();
      this.fetchAvailability(this.dataset.variantId);
    }

    renderError() {
      this.innerHTML = '';
      const message = document.createElement('p');
      message.textContent = this.dataset.errorMessage;
      const refresh = document.createElement('button');
      refresh.type = 'button';
      refresh.className = 'pickup-availability-information__button text-button';
      refresh.textContent = this.dataset.refreshLabel;
      refresh.addEventListener('click', this.onClickRefreshList);
      this.append(message, refresh);
      this.setAttribute('available', '');
    }

    renderPreview(sectionInnerHTML) {
      const drawer = document.querySelector('.pickup-availability-drawer');
      if (drawer) drawer.remove();

      const pickupInformation = sectionInnerHTML?.querySelector('.pickup-availability-information');
      if (!pickupInformation) {
        this.clearAvailability(this.dataset.variantId);
        return;
      }

      this.innerHTML = pickupInformation.innerHTML;
      this.setAttribute('available', '');

      const pickupDrawer = document.getElementById('Pickup-Availability');
      const pickupDrawerContent = sectionInnerHTML.querySelector('.side-availability');
      if (pickupDrawer) {
        pickupDrawer.innerHTML = pickupDrawerContent?.innerHTML || '';
      }

      const button = this.querySelector('button');
      if (button) button.addEventListener('click', (evt) => {
        if (!pickupDrawer) return;

        pickupDrawer.classList.toggle("active");
        document.getElementsByTagName("body")[0].classList.toggle('open-cc');

        evt.preventDefault();
      });
    }
  });
}
